export default __webpack_public_path__ + "static/media/earning.25760010.jpg";